import { m } from '~/paraglide/messages'

export function selectRewardHeading({ isDuplicate }: { isDuplicate: boolean }) {
  return isDuplicate ? m.duplicate_item_reclaimed : m.claimed_title
}
